<script setup>
import HighlightableField from "@/components/projects/HighlightableField/HighlightableField";

defineProps({
  currentProject: {
    type: Object,
    required: true,
  },
  candidate: {
    type: Object,
    required: true,
  },
  project: {
    type: Object,
    required: true,
  },
  tokensEnabled: {
    type: Boolean,
    default: false,
  },
});

const formatDate = (proj) => {
  if (!proj) return "";

  const start = proj.startTime;
  const end = proj.endTime;

  if (start && end) return `${start} - ${end}`;
  if (start) return start;
  if (end) return end;

  return "";
};

const getDisplayUrl = (url) => {
  if (!url) return "";
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.replace("www.", "");
  } catch {
    return url;
  }
};
</script>

<template>
  <div class="mb-4 project-item">
    <div v-if="project.title">
      <HighlightableField
        :enabled="tokensEnabled"
        :project="currentProject"
        :candidate="candidate"
        :token-text="project.title"
        token-type="plain"
        :additional-token-types="['plain']"
        :similarity-tokens="[]"
      />
      <span v-if="formatDate(project)" class="date-label">
        ({{ formatDate(project) }})
      </span>
    </div>

    <div v-if="project.description" class="project-description">
      <HighlightableField
        :enabled="tokensEnabled"
        :project="currentProject"
        :candidate="candidate"
        :token-text="project.description"
        token-type="plain"
        :additional-token-types="['plain']"
        :similarity-tokens="[]"
      />
    </div>

    <div v-if="project.projectUrl" class="project-url">
      <a :href="project.projectUrl" target="_blank" rel="noopener noreferrer">
        <span class="material-icons-outlined md-14">link</span>
        {{ getDisplayUrl(project.projectUrl) }}
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.project-item {
  color: $tf-font-default;

  .date-label {
    color: $tf-font-ghost;
    margin-left: 4px;
  }

  .project-description {
    color: $tf-font-ghost;
    margin-top: 4px;
    font-size: 14px;
  }

  .project-url {
    margin-top: 4px;
    font-size: 14px;

    a {
      color: $blue-100;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 4px;

      &:hover {
        text-decoration: underline;
      }

      .material-icons-outlined {
        font-size: 14px;
      }
    }
  }
}
</style>

